import {IMessage} from '../../index';
import {global} from '../../appContext';
import {getHash} from '../../constants/RouteDefinitions';
import {escapeHTML} from '../../util/misc';
import {nsMessageFlowClone} from '../../clone/nsMessageFlowClone';
import {IPageShellHeaderActions} from '../page-shell/pageShellHeaderActions';
import {nsMessages} from './fn';
import {nsFa} from '../fa/fn';
import i = nsFa.i;

/** Message flow actions for the page heading: preview/edit up front, copy and delete behind "Mer". */
export function buildMessageFlowActions(message: IMessage): IPageShellHeaderActions {
    const pv = global.permissionValidator;

    return {
        quick: [
            {
                icon: 'fa-eye',
                label: 'preview',
                onClick: () => previewMessageFlow(message),
                validator: () => pv.isMinSuperManager(),
            },
            {
                icon: 'fa-pencil',
                label: 'edit',
                href: () => getHash('editmessageflow', {id: message.id}) ?? '',
                validator: () => pv.isMinCompanyAdmin(),
            },
        ],
        more: [
            {
                icon: 'fa-copy',
                label: 'copy',
                onClick: () => nsMessages.copyMessageDialogWithoutLog(message),
                validator: () => pv.isMinCompanyAdmin(),
            },
            {
                cls: 'btn-destructive explicit',
                icon: 'fa-trash-alt',
                label: 'delete',
                onClick: () => nsMessageFlowClone.trashDialog(message),
                validator: () => pv.isMinCompanyAdmin(),
            },
        ],
    };
}

export function previewMessageFlow(message: IMessage): void {
    global.dialogManager.addComponent({
        title: `${i('fa-eye')} ((preview message)) [${escapeHTML(message.name)})]`,
        fullWidth: true,
        content: {
            name: 'component/messages/preview',
            params: {message},
        },
    });
}
